import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import CardComponent from '../../components/CardComponent';
import PageFade from '../../components/Login/PageFade';
import { getAttendanceItems } from '../../services/AppService';
import { useAuth } from '../../context/AuthContext';


const Attendance = () => {
  const [cards, setCards] = useState([]);
  const {user} = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    const fetchData = async () => {
      const data = await getAttendanceItems(user);
      setCards(data);
    };
    fetchData();
  }, [user]);

  return (
    <PageFade>
      <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-3 justify-items-center">
        {cards.map((card, index) => (
          <CardComponent
            key={index}
            imgSrc={card.image}
            title={card.title}
            translationKey={card.translationKey}
            onClick={() => navigate(card.link)}
          />
        ))}
      </div>
    </PageFade>
  );
};

export default Attendance;